import { TextureLoader } from 'three'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { Font, FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import EventEmitter from './EventEmitter'

export default class Loaders extends EventEmitter
{
    constructor()
    {
        super()
        this.setLoaders()

        this.toLoad = 0
        this.loaded = 0
        this.items = {}
    }

    setLoaders()
    {
        this.loaders = []

        // Textures
        const textureLoader = new TextureLoader()
        this.loaders.push({
            extensions: ['jpg', 'jpeg', 'png', 'webp'],
            action: (_resource) =>
            {
                _resource.type = this.Types.Texture
                textureLoader.load(_resource.source, (_data) =>
                {
                    this.fileLoadEnd(_resource, _data)
                })
            }
        })

        // Draco
        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('draco/')
        dracoLoader.setDecoderConfig({ type: 'js' })
        dracoLoader.preload()
        this.loaders.push({
            extensions: ['drc'],
            action: (_resource) =>
            {
                _resource.type = this.Types.Model
                dracoLoader.load(_resource.source, (_data) =>
                {
                    this.fileLoadEnd(_resource, _data)
                    DRACOLoader.releaseDecoderModule()
                })
            }
        })

        // Gltf
        const gltfLoader = new GLTFLoader()
        gltfLoader.setDRACOLoader(dracoLoader)
        this.loaders.push({
            extensions: ['gltf', 'glb'],
            action: (_resource) =>
            {
                _resource.type = this.Types.Model
                gltfLoader.load(_resource.source, (_data) =>
                {
                    this.fileLoadEnd(_resource, _data)
                })
            }
        })

        // Font
        const fontLoader = new FontLoader()
        this.loaders.push({
            extensions: ['json'],
            action: (_resource) =>
            {
                _resource.type = this.Types.Font
                this.fileLoadEnd(_resource, fontLoader.parse(_resource.source))
            }
        })
    }

    load(_resources = [])
    {
        for(const _resource of _resources)
        {
            this.toLoad++

            let extension
            if(typeof _resource.source === 'object') {
                extension = 'json'
            } else {
                const extensionMatch = _resource.source.match(/\.([a-z]+)$/)
                if(typeof extensionMatch !== 'undefined') {
                    extension = extensionMatch[1]
                } else {
                    console.warn('Cannot find extension for', _resource)
                    break
                }
            }
            
            const loader = this.loaders.find((_loader) => _loader.extensions.find((_extension) => _extension === extension))

            if(loader) {
                loader.action(_resource)
            }
            else {
                console.warn('Cannot find loader for', _resource)
            }
        }
    }

    fileLoadEnd(_resource, _data)
    {
        this.loaded++
        this.items[_resource.name] = _data

        this.trigger('fileEnd', [_resource, _data])
        if(this.loaded === this.toLoad)
        {
            this.trigger('end')
        }
    }

    Types =
    {
        Texture: 0,
        Model: 1,
        Font: 2
    }
}